import { useApiClient, useEntityMetadata, useHomeSitemap, useNavigation } from '@msdk/common'
import { EntityModel, TenantPath, UserPath } from '@msdk/definitions'
import { useEffect, useState } from 'react'

export function useDataRetentionConfirmed() {
  const [result, setResult] = useState<boolean | undefined>(undefined)
  const client = useApiClient()
  const navigation = useNavigation()
  const getHomeSitemap = useHomeSitemap()
  const entityModel = useEntityMetadata('DPR_CONFIGURATION') as EntityModel
  const tenant = new TenantPath()
  const isDPREnabled = tenant.IsMicroServiceEnabled('DPR')
  const isPAMEnabled = tenant.IsMicroServiceEnabled('PAM')
  const userPath = new UserPath()
  const isDPOLogged = userPath.HasRole('app.dpo')
  const isAdminLogged = userPath.HasRole('app.admin')
  useEffect(() => {
    const fetchdata = async () => {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      if (!isDPREnabled || (!isDPOLogged && !isAdminLogged) || (isDPREnabled && !entityModel)) {
        setResult(true)
      } else {
        const entityOperation = await client.entity.getSingleton('DPR', '', entityModel)
        let isDataRetentionConfirmed = false
        if (entityOperation && entityOperation.entities && entityOperation.entities.length > 0) {
          const entity = entityOperation?.entities[0]
          isDataRetentionConfirmed = entity?.fields['DPR_CONFIGURATION_CONFIRMATION']?.value === '1'
          if (isDataRetentionConfirmed && isPAMEnabled) {
            isDataRetentionConfirmed = entity?.fields['DPR_CONFIGURATION_CONFIRMATION_PAM']?.value === '1'
          }
        }
        setResult(isDataRetentionConfirmed)
      }
    }
    fetchdata().catch(console.error)
  }, [])

  const onClose = async () => {
    const sitemapName = await getHomeSitemap()
    navigation(
      'DPR_CONFIGURATION/DPR_CONFIGURATION_FORM/00000000-0000-0000-0000-000000000000',
      sitemapName,
      undefined,
      new URLSearchParams({
        mode: 'Readonly',
      }),
    )
  }
  return { result, onClose }
}
